import React from 'react';
import { Box, Typography } from '@mui/material';
import Logo from '../../assets/19.png'; // Imagem da logo

const Footer = ({ backgroundColor }) => {
  return (
    <Box
      sx={{
        backgroundColor: backgroundColor || '#103874', // Cor de fundo personalizada ou padrão
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#ffffff',
        position: 'relative',
        height: 'auto',
        width: '100%',
        flexWrap: 'wrap', // Ajusta o layout em telas menores
        padding: 2,
      }}
    >
      {/* Logo da empresa */}
      <Box
        component="img"
        src={Logo}
        alt="Logo da empresa"
        sx={{
          width: { xs: '180px', sm: '220px', md: '280px' },
          height: 'auto',
        }}
      />

      {/* Contêiner de texto */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: { xs: 'center', sm: 'right' },
          padding: { xs: 1, sm: 5 },
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        {/* Contatos */}
        <Typography variant="body1" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
          Telefone: (11) 4357-9243
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
          E-mail: atendimentoclienteargus@gmail.com
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '0.5rem', sm: '0.4rem' } }}>
          Endereço: Av. Firestone 478, Santo André, SP, 09195-470
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: 'block', mt: 1, fontSize: { xs: '0.5rem', sm: '0.4rem' } }}
        >
          Argus Consultoria de Seguros, é uma empresa filiada a RivaSeg Corretora de Seguros, SUSEP
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
